// src/pages/Users/Techniques/ui/ToolbarIconButton.jsx

import React from "react";

export default function ToolbarIconButton({
  children,
  active,
  onClick,
  title,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border text-base transition active:scale-95 ${
        active
          ? "border-emerald-200 bg-emerald-50 text-emerald-600 dark:border-emerald-900/60 dark:bg-emerald-950/30 dark:text-emerald-300"
          : "border-slate-200 bg-slate-50 text-slate-500 hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300 dark:hover:bg-slate-800"
      }`}
    >
      {children}
    </button>
  );
}